var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.116 21.374l-.246-.152a5.452 5.452 0 00-6.106 0 4.027 4.027 0 01-2.463.767 4.015 4.015 0 01-2.462-.767 5.14 5.14 0 00-3.055-.936 5.125 5.125 0 00-3.05.936 4.03 4.03 0 01-2.464.767 4.016 4.016 0 01-2.46-.767 6.286 6.286 0 00-1.423-.704L2 22.194a5.024 5.024 0 011.175.589 5.13 5.13 0 003.046.938 5.124 5.124 0 003.045-.938 3.992 3.992 0 012.452-.764 4.022 4.022 0 012.457.764 5.108 5.108 0 003.043.938 5.117 5.117 0 003.043-.938 4.325 4.325 0 014.91 0c.022.014.045.03.07.044zm-.449-6.676l-1.662-6.662c-.054-.182-.207-.252-.465-.252h-2.41l-.374-1.744a.449.449 0 00-.576-.265l-.005.002L17.45 6.93a.594.594 0 00-.447.664v2.123H6.987a.49.49 0 00-.46.45l-1.008 4.52H3.84a.428.428 0 00-.431.326l-.726 3.774a7.998 7.998 0 011.721.708 3.212 3.212 0 001.83.492 3.22 3.22 0 001.833-.492 7.167 7.167 0 013.684-.947 7.171 7.171 0 013.688.947 3.214 3.214 0 001.83.492 3.207 3.207 0 001.83-.492 7.188 7.188 0 013.69-.947 7.167 7.167 0 013.686.947l.272.14 3.197-4.347a.39.39 0 00-.376-.59zm-14.34 0H6.755l.508-2.394h4.065zm5.551 0h-4.64v-2.394h4.64zm.875 0v-2.394h4.6l.482 2.394z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--boat-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'BoatIcon';
export default Icon;